import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from 'jquery';
import { render, unmountComponentAtNode } from 'react-dom';

import { KeyCode } from '../util/Constants';

window.jQuery = $;
require('textarea-helper');
delete window.jQuery;

const { UP, DOWN, ENTER, ESCAPE } = KeyCode;

import './TextareaSuggestions.css';
import { TextWithEllipsisFileExtension } from '../common/TextWithEllipsis';
export const textareaSuggestionsProps = {
  onTextChange: PropTypes.func
};

export type textareaSuggestionsPropFlowTypes = {
  onTextChange: () => void
};

const TextareaSuggestions = (getTextarea, getSuggestions, getAcceptSuggestion) => (Component) =>
  class TextareaSuggestions extends React.Component {
    static WrappedComponent = Component;

    constructor(props) {
      super(props);

      const div = (this._div = document.createElement('div'));
      document.body.appendChild(div);

      this.state = {
        show: false,
        activeIndex: 0,
        suggestions: []
      };
    }

    componentDidUpdate(prevProps, prevState) {
      this.renderSuggestions();

      try {
        if (this.state.activeIndex !== prevState.activeIndex || this.state.show !== prevState.show) {
          this._list.childNodes[this.state.activeIndex].scrollIntoViewIfNeeded();
        }
      } catch (e) {
        // no op
      }
    }

    init = (component) => {
      const suggestions = getSuggestions(component);
      if (!(suggestions && Array.isArray(suggestions))) {
        throw new Error('[TextareaSuggestions] getSuggestions() did not return an array');
      }

      const acceptSuggestion = getAcceptSuggestion(component);
      if (typeof acceptSuggestion !== 'function') {
        throw new Error('[TextareaSuggestions] getAcceptSuggestion() did not return a function');
      }

      this._component = component;
      this._allSuggestions = suggestions;
      this._acceptSuggestion = acceptSuggestion;

      this.setState({ suggestions });
    };

    cleanup = () => {
      this.unmountPortal();
    };

    unmountPortal = () => {
      unmountComponentAtNode(this._div);
      document.body.removeChild(this._div);
    };

    onMount = (component) => {
      return component ? this.init(component) : this.cleanup();
    };

    filterSuggestions = (str) => {
      let suggestions = [...this._allSuggestions];

      if (str.trim().length > 0) {
        suggestions = suggestions.filter((u) => u.label.toLowerCase().indexOf(str.toLowerCase()) > -1);
      }

      this.setState({
        suggestions: _.sortBy(suggestions, 'label')
      });
    };

    showSuggestions = () => {
      const textarea = getTextarea(this._component);
      textarea.addEventListener('keydown', this.onKeyDown);
      $(textarea).textareaHelper();
      this.filterSuggestions('');
      this._div.style.display = 'block';
      document.addEventListener('click', this.onDocumentClick);
      this.setState({ show: true, activeIndex: 0 });
    };

    hideSuggestions = () => {
      const textarea = getTextarea(this._component);
      if (textarea) {
        textarea.removeEventListener('keydown', this.onKeyDown);
      }
      this._div.style.display = 'none';
      document.removeEventListener('click', this.onDocumentClick);
      this.setState({ show: false });
    };

    getSuggestionPrefix = (value, selectionStart) => {
      let i = selectionStart;
      let prefix = '';
      while (i >= 0) {
        i--;
        prefix = value[i] + prefix;

        if (value[i] === '@') {
          break;
        }
      }

      return prefix;
    };

    acceptSuggestion = (suggestion) => {
      const textarea = getTextarea(this._component);
      const { value, selectionStart } = textarea;
      const prefix = value.substring(0, selectionStart);
      const suffix = value.substring(selectionStart, value.length);
      const index = prefix.lastIndexOf('@') + 1;
      const newValue = prefix.substring(0, index) + suggestion.label + ' ' + suffix;
      const caretIndex = newValue.length - suffix.length;

      this._acceptSuggestion(suggestion, newValue);

      textarea.focus();
      setTimeout(() => {
        textarea.setSelectionRange(caretIndex, caretIndex);
      }, 25);
    };

    onSuggestionClick = (suggestion) => {
      this.hideSuggestions();
      this.acceptSuggestion(suggestion);
    };

    onDocumentClick = (e) => {
      const nodes = $(e.target)
        .parents()
        .get();
      if (!_.includes(nodes, this._div) && this.state.show) {
        this.hideSuggestions();
      }
    };

    onKeyDown = (e) => {
      const { suggestions, show, activeIndex } = this.state;

      if (!show || !suggestions.length || !_.includes([UP, DOWN, ENTER, ESCAPE], e.keyCode)) {
        return;
      }

      if (e.keyCode === DOWN) {
        e.preventDefault();
        this.setState({
          activeIndex: Math.min(activeIndex + 1, suggestions.length - 1)
        });
      } else if (e.keyCode === UP) {
        e.preventDefault();
        this.setState({
          activeIndex: Math.max(activeIndex - 1, 0)
        });
      } else if (e.keyCode === ENTER) {
        e.preventDefault();
        this.acceptSuggestion(suggestions[activeIndex]);
        this.hideSuggestions();
      } else if (e.keyCode === ESCAPE) {
        this.hideSuggestions();
      }
    };

    onChange = (e) => {
      const { value, selectionStart } = e.target;
      const prefix = this.getSuggestionPrefix(value, selectionStart);
      const lastChar = prefix[prefix.length - 1];

      if (lastChar === '@') {
        this.showSuggestions();
      } else if ((value.trim().length === 0 || /\s/.test(lastChar) || lastChar !== '@') && this.state.show) {
        this.hideSuggestions();
      } else if (this.state.show) {
        this.filterSuggestions(prefix.substring(1));
      }
    };

    renderSuggestions = () => {
      const { show, activeIndex, suggestions } = this.state;
      if (!show) {
        return null;
      }

      const textarea = getTextarea(this._component);
      const div = this._div;
      const pos = $(textarea).textareaHelper('caretPos');
      const textareaRect = textarea.getBoundingClientRect();

      let top = textareaRect.top + pos.top + 25;
      let bottom = '';
      if (top > window.innerHeight - 150) {
        top = '';
        bottom = window.innerHeight - textareaRect.top - pos.top + 5;
      }

      let left = textareaRect.left + pos.left;
      let right = '';
      if (left > window.innerWidth - 261) {
        left = '';
        right = 1;
      }

      const position = { top, right, bottom, left };
      const style = {
        ...position,
        maxHeight: `${Math.min(window.innerHeight - top, 200)}px`,
        fontSize: '12px'
      };

      const list = (
        <ul name="TextareaSuggestions" style={style} ref={(node) => (this._list = node)}>
          {suggestions.map((s, i) => (
            <li key={s.value} onClick={() => this.onSuggestionClick(s)} className={i === activeIndex ? 'active' : ''}>
              {s.icon ? (
                <div style={{ width: '22px', height: '22px' }}>
                  <img src={s.icon} />{' '}
                </div>
              ) : null}
              {/* <span title={s.label}>{s.label}</span> */}
              <TextWithEllipsisFileExtension
                title={s.label}
                text={s.label}
                style={{ margin: 'unset', padding: '0 10px', color: 'unset' }}
              />
            </li>
          ))}
        </ul>
      );

      render(list, div);
    };

    render() {
      return <Component {...this.props} ref={this.onMount} onTextChange={this.onChange} />;
    }
  };

export default TextareaSuggestions;
